module.exports = __webpack_public_path__ + "img/diversity.d64171e.jpg";